// Theme registry - maps skinName to theme modules
import SpectrumTheme from './spectrum';
import CyanTheme from './cyan';
import BlazeTheme from './blaze';
import DefaultTheme from './default';
import { BLAZE_SOUND_CONFIG } from './blaze/sounds';
import { FROST_SOUND_CONFIG } from './cyan/sounds';
import { SPECTRUM_SOUND_CONFIG } from './spectrum/sounds';
import { DEFAULT_SOUND_CONFIG } from './default/sounds';

// Theme registry
export const THEME_REGISTRY = {
  'Spectrum': SpectrumTheme,
  'Cyan': CyanTheme,
  'Blaze': BlazeTheme,
  'Default': DefaultTheme,
};

/**
 * Theme Sound Registry - maps board IDs to sound configurations
 * Board IDs come from BoardSkinContext (inferno, frost, spectrum)
 */
export const THEME_SOUND_REGISTRY = {
  'inferno': BLAZE_SOUND_CONFIG,  // Inferno board uses Blaze sounds
  'frost': FROST_SOUND_CONFIG,    // Frost board uses crystalline ice sounds
  'spectrum': SPECTRUM_SOUND_CONFIG,    // Spectrum theme sounds
  'none': DEFAULT_SOUND_CONFIG,         // Default board - blaster for line clears only
};

// Get theme by name
export const getTheme = (skinName) => {
  return THEME_REGISTRY[skinName] || SpectrumTheme;
};

// Get theme async (for code splitting - future optimization)
export const getThemeAsync = async (skinName) => {
  return THEME_REGISTRY[skinName] || SpectrumTheme;
};

// Get theme sound config by board ID
export const getThemeSoundConfig = (boardId) => {
  return THEME_SOUND_REGISTRY[boardId] || null;
};

// Export individual themes
export { default as SpectrumTheme } from './spectrum';
export { default as CyanTheme } from './cyan';
export { default as BlazeTheme } from './blaze';

// Default export
export default {
  getTheme,
  getThemeAsync,
  getThemeSoundConfig,
  THEME_REGISTRY,
  THEME_SOUND_REGISTRY,
};
